import React from "react"
import Layout from '../containers/layout/layout'
import SEO from "../components/seo"
import ErrorArea from '../containers/error-area'

export const Head = () => <SEO title="404: Not found" />

const NotFoundPage = ({location}) => (
  <Layout location={location}>
    <ErrorArea/>
  </Layout>
)

export default NotFoundPage
